import { render, staticRenderFns } from "./breedsSelector.vue?vue&type=template&id=11a6b62f&scoped=true&"
import script from "./breedsSelector.vue?vue&type=script&lang=js&"
export * from "./breedsSelector.vue?vue&type=script&lang=js&"
import style0 from "./breedsSelector.vue?vue&type=style&index=0&id=11a6b62f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6b62f",
  null
  
)

export default component.exports